<template>
  <section class="branches">
    <custom-card
      :description="
        !this.loading ? 'selecione a filial' : 'por favor aguarde...'
      "
      :height="!this.loading ? '532' : null"
    >
      <!-- busca -->
      <b-form-input
        class="mb-3"
        v-if="branches.length > perPage"
        v-model="search"
        placeholder="Encontre a filial pelo nome"
      />

      <!-- branches -->
      <ul class="branch-list mt-5" v-if="!loading">
        <Branch
          v-for="branch in filteredBranches"
          :key="branch._id"
          :branch="branch"
          @loading-branch-data="onLoad"
        />

        <li v-if="!filteredBranches.length">
          Não há nenhuma filial a ser exibida.
        </li>
      </ul>

      <div class="d-flex justify-content-center" v-else>
        <div class="spinner-border" role="status"></div>
      </div>

      <!-- paginação -->
      <b-pagination
        class="mt-5"
        pills
        v-if="branches.length > perPage && !search"
        v-model="currentPage"
        :total-rows="totalBranches"
        :per-page="perPage"
      />
    </custom-card>
  </section>
</template>

<script>
import CustomCard from "@/components/Utils/CustomCard.vue";
import Branch from "@/components/SelectBranch/Branch.vue";
import { toast } from "@/helpers/toast";
import { getActiveCompany, getActiveUser } from "@/helpers/storage";
import { mapGetters } from "vuex";

export default {
  name: "select-branch",
  data() {
    return {
      currentPage: 1,
      perPage: 3,
      search: "",
      loading: false
    };
  },
  components: {
    CustomCard,
    Branch
  },
  computed: {
    ...mapGetters(["getSignedUser"]),
    feathers() {
      return this.$FeathersVuex.api;
    },
    branches() {
      const branches = this.feathers.Branch.findInStore({
        query: { company: getActiveCompany() }
      }).data;
      const user = this.user;
      let result = branches;

      if (user.branches && user.branches.length) {
        let aux = new Set();

        user.branches.forEach(id => {
          branches
            .filter(branch => branch._id === id)
            .forEach(branch => aux.add(branch));
        });

        result = Array.from(aux);
      }

      return result;
    },
    user() {
      return this.getSignedUser;
    },
    totalBranches() {
      return this.branches.length;
    },
    indexOfLastBranch() {
      return this.currentPage * this.perPage;
    },
    indexOfFirstBranch() {
      return this.indexOfLastBranch - this.perPage;
    },
    currentBranches() {
      return this.branches.slice(
        this.indexOfFirstBranch,
        this.indexOfLastBranch
      );
    },
    filteredBranches() {
      if (this.search !== "") {
        return this.branches.filter(branch =>
          branch.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        return this.currentBranches;
      }
    }
  },
  created() {
    if (!this.branches.length) {
      this.$router.push("/");
    }
  },
  methods: {
    onLoad($event) {
      this.loading = $event;

      if (!$event)
        toast(
          this,
          "Ocorreu um erro",
          "Não foi possível obter as informações da filial",
          3000,
          "danger"
        );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
